export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "ICICI Bank Home Loan EMI Calculator: Plan Your Home Loan Repayments with Confidence",
    subHeading:
      "Use ICICI Bank’s Home Loan EMI Calculator to instantly determine the monthly EMI on your home loan. With just a few simple details—loan amount, interest rate, and loan tenure—you can accurately estimate your monthly repayments. This tool is designed to help you understand your financial commitment and make informed decisions for a stress-free borrowing experience.",

    notice:
      "The calculations provided are for illustrative purposes only. Actual loan terms may vary based on the lender’s policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
